export default "__VITE_ASSET__C2mn0g2i__"